import { Logger } from '@/utils/logger';
import { AuthService } from '@montugroup/circuit-shared/services/authentication.service';
import { Box } from '@montugroup/design-system';
import React from 'react';
import Header from '../layout/Header';

const logger = new Logger('auth/SignOut');

function SignOut() {
  React.useEffect(() => {
    logger.info('useEffect logout');
    AuthService.logout();
  }, []);

  return (
    <>
      <Header />
      <Box>Signing out...</Box>
    </>
  );
}

export default SignOut;
